import { render } from "./UserTasks.vue?vue&type=template&id=67c7c434"
import script from "./UserTasks.vue?vue&type=script&lang=js"
export * from "./UserTasks.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__